import { AddPhotoAlternateOutlined, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { useRef } from 'react';
import addLogo from "../assets/images/AddLogo.svg";
import { MuiIconButton, MuiStack } from '.';
import { Avatar } from "@mui/material";

export const MuiLogo = (props: any) => {
    const { src, onChange, disableEdit, disableDelete, disableAdd, height, width, ...others } = props;

    const inputRef = useRef<HTMLInputElement | null>(null);

    const deleteImage = () => {
        if (!inputRef?.current) return;
        inputRef.current.value = ''
        onChange(null);
    }
    const handleImageChange = async (e: any) => {
        onChange(e);
    };

    return (
        <>
            <input
                type="file"
                multiple
                onChange={handleImageChange}
                hidden
                accept="image/*"
                ref={inputRef}
            />

            {src ? (
                <Avatar
                    variant="square"
                    alt="file"
                    src={src}
                    sx={{
                        placeSelf: 'center',
                        height: height ? height : '50%',
                        minHeight: height ? height : "90%",
                        minWidth: width ? width : "95%",
                        border: "1px solid",
                    }}
                />
            ) : (
                <Avatar
                    variant="square"
                    alt="addLogo"
                    src={addLogo}
                    sx={{
                        placeSelf: 'center',
                        height: height ? height : '50%',
                        minHeight: height ? height : "95%",
                        minWidth: width ? width : "95%",
                        border: "1px solid",
                    }}
                />
            )}
            <MuiStack>
                {src ?
                    !disableEdit && <MuiIconButton
                        tooltipTitle={'Edit'}
                        onClick={() => inputRef.current?.click()}
                        size="small"
                    >
                        <EditOutlined />
                    </MuiIconButton> :
                    !disableAdd && <MuiIconButton
                        tooltipTitle={'Add'}
                        onClick={() => inputRef.current?.click()}
                        size="small"
                    >
                        <AddPhotoAlternateOutlined />
                    </MuiIconButton>
                }
                {!disableDelete && src &&
                    <MuiIconButton
                        tooltipTitle="Delete"
                        onClick={deleteImage}
                        size="small"
                    >
                        <DeleteOutlined />
                    </MuiIconButton>}
            </MuiStack>
        </>
    )
}